module.exports = __webpack_public_path__ + "static/media/gencash.48311ad4.svg";